import { DISPLAY_DATE } from "constants/date";
import dayjs from "dayjs";

export const MessageDateFormat = ({
  createdAt,
}: {
  createdAt?: string | Date;
}) => {
  const dateObj = dayjs(createdAt || undefined);

  let date: string;

  if (dateObj.isToday()) {
    date = dateObj.format("hh:mm a");
  } else if (dateObj.year() === dayjs().year()) {
    date = dateObj.format("MMM D");
  } else {
    date = dateObj.format(DISPLAY_DATE);
  }

  return <>{date}</>;
};
